'use es6';

import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useControlsContext } from '../context';
import { getEventValue } from '../../../utils/jsEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const EmailSubjectTextInput = () => {
  const {
    emailSubject,
    setEmailSubject
  } = useControlsContext();
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.emailSubjectLabel"
    }),
    children: /*#__PURE__*/_jsx(UITextInput, {
      defaultValue: emailSubject,
      onChange: e => setEmailSubject(getEventValue(e)),
      "data-test-id": "email-report-subject-text-input"
    })
  });
};
export default EmailSubjectTextInput;